import ClientsPage from './clients/ClientsPage';
import EmailTemplatesPage from './email-templates/EmailTemplatesPage';
import LeadsPage from './leads/LeadsPage';
import LessonsController from './lessons/LessonsController';
import OfferPage from './offer/OffersPage';
import ReservationsPage from './reservations/ReservationsPage';
import SettingsPage from './settings/SettingsPage';
import SlotsPage from './slots/SlotsPage';
import TeachersPage from './teachers/TeachersPageWithTable';
import { createElement } from 'react';
import { Navigate } from 'react-router-dom';

export const AdminRoutes = [
    {
        index: true,
        element: createElement(Navigate, { to: '/admin/terminy', replace: true }),
    },
    {
        path: '/admin/terminy/:slotId?',
        Component: SlotsPage
    },
    {
        path: '/admin/rezerwacje',
        Component: ReservationsPage
    },
    {
        path: '/admin/grafik/:lessonId?',
        Component: LessonsController
    },
    {
        path: '/admin/klienci/:clientId?',
        Component: ClientsPage
    },
    {
        path: '/admin/zgłoszenia',
        Component: LeadsPage
    },
    {
        path: '/admin/korepetytorzy',
        Component: TeachersPage
    },
    {
        path: '/admin/oferta',
        Component: OfferPage
    },
    {
        path: '/admin/szablony-maili',
        Component: EmailTemplatesPage
    },
    {
        path: '/admin/ustawienia',
        Component: SettingsPage
    }
]